import { RouteEnum } from 'pro/config/routers';

export type lightType = {
    intensity?: number,
    position?: [number, number, number],
    color?: string,
    [key: string]: any;
}

// 3d 模型配置
export type IThreeDConfigType = {
    camera?: {
        position?: [number, number, number];
    },
    directionalLight?: lightType[];   // 平行光
    pointLight?: lightType[];         // 点光
    orbitControls?: Record<string, any>;
}
export type ICategoryProduct = {
    key: string;
    serie: string;
    url: string;
    variantId: string;
    picture: string;
    manual: string;
    features?: Array<Array<{
        icon: string;
        title: string;
        description?: string;
    }>>;
};

export type ICategory = {
    key: string;
    name: string;
    shortName: string;
    url: string;
    isAccessory: boolean;
    description: string[];
    children: ICategoryProduct[];
};

export const CATEGORIES: ICategory[] = [
    {
        key: 'vegadynaseries',
        name: 'VEGA Dyna Series',
        shortName: 'VEGA DYNA Series',
        url: RouteEnum.CAT_VEGA_DYNAMIC_SERIES,
        isAccessory: false,
        description: [
            'Crafted with precision and designed for excellence, the dynamic VEGA series empowers professional growers with unparalleled control and efficiency.',
            'Its spectrum tunability and compatibility with HPS redefine flexibility, delivering optimal conditions for plant growth and development.'
        ],
        children: [
            {
                key: 'vegadyna',
                serie: 'VEGA Dyna',
                url: RouteEnum.PROD_VEGA_DYNA,
                variantId: '166346871036870658',
                picture: 'asset/width-1372/picture/6e486e3ca475fe26eac1ec0323123919.png',
                manual: '',
                features: [
                    [
                        { title: 'Tunable Spectrum', icon: 'file-asset/file/6ec8c6cf94385434372c38a8a184fa75/1751963815999/1.svg' },
                        { title: '1:1 HPS Replacement', icon: 'file-asset/file/6ec8c6cf94385434372c38a8a184fa75/1751963815999/2.svg' },
                        { title: 'PPE 3.0 µmol/J', icon: 'file-asset/file/6ec8c6cf94385434372c38a8a184fa75/1751963815999/3.svg' }
                    ],
                    [
                        { title: 'Modular Design', icon: 'file-asset/file/6ec8c6cf94385434372c38a8a184fa75/1751963815999/4.svg' },
                        { title: 'Uniform High Light Intensity', icon: 'file-asset/file/6ec8c6cf94385434372c38a8a184fa75/1751963815999/5.svg' },
                        { title: 'Excellent Heat Dissipation', icon: 'file-asset/file/6ec8c6cf94385434372c38a8a184fa75/1751963815999/6.svg' },
                    ]
                ]
            }
        ]
    },
    {
        key: 'de1000w',
        name: 'DE 1000W',
        shortName: 'DE 1000W',
        url: RouteEnum.CAT_DE,
        isAccessory: false,
        description: [
            'The Matrix DE 1000W is a powerhouse in double-ended HPS lighting, designed to deliver a concentrated red spectrum with unparalleled uniformity.',
            'This cutting-edge solution drives vigorous flowering, dense bud development, and superior resin production, ensuring top-tier results for serious growers.'
        ],
        children: [
            {
                key: 'de',
                serie: 'DE',
                url: RouteEnum.PROD_DE,
                variantId: '166225847447969830',
                picture: 'asset/width-1372/picture/b5434eb91426733e38acb113fbb232cc.png',
                manual: '',
                features: [
                    [
                        { title: 'PPE 2.1 µmol/J', icon: 'file-asset/file/8ad6d8d29851703d153de4bfd5933786/1751963820867/1.svg' },
                        { title: 'High Output', icon: 'file-asset/file/8ad6d8d29851703d153de4bfd5933786/1751963820867/3.svg' },
                    ],
                    [
                        { title: 'Over 98% Highly Reflective Aluminum', icon: 'file-asset/file/8ad6d8d29851703d153de4bfd5933786/1751963820867/2.svg' },
                        { title: '0-10V Dimming from 50% to 115%', icon: 'file-asset/file/8ad6d8d29851703d153de4bfd5933786/1751963820867/4.svg' }
                    ]
                ]
            }
        ]
    },
    {
        key: 'mseries',
        name: 'M Series', // 分类名
        shortName: 'M Series',
        url: RouteEnum.CAT_M_SERIES,
        isAccessory: false,
        description: [
            'The Matrix M series, equipped with efficient Samsung 301H EVO diodes and high-efficiency red diodes, delivers exceptional light output and an impressive PPE of 3.0μmol/J.',
            'The incorporation of rich red and blue light not only accelerates plant growth and increases yield but also enhances the production of target components within plants.'
        ],  // 分类描述，在 All Products 页面展示
        children: [
            {
                key: 'm4',
                serie: 'M4',
                url: RouteEnum.PROD_M4,
                variantId: '166182562498965504',
                picture: 'asset/width-940/picture/4832d89e93b2f0b303ae952dc8535fc1.png',
                manual: 'file-asset/file/68d616d0c049b946004ada399a9f07ca.pdf',
                features: [
                    [
                        { title: 'PPE 3.1 µmol/J', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/1.svg' },
                        { title: 'Uniform High Light Intensity', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/2.svg' },
                        { title: 'Dimming Down to 25%', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/3.svg' },
                    ],
                    [
                        { title: 'Vegetative Growth', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/4.svg' },
                        { title: 'Superior Energy Efficiency', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/5.svg' },
                        { title: 'Excellent Heat Dissipation', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/6.svg' },
                    ]
                ]
            },
            {
                key: 'm6',
                serie: 'M6',
                url: RouteEnum.PROD_M6,
                variantId: '166249243745576964',
                picture: 'asset/width-1372/picture/5469abfb4d109160b6fc9bb9a452057b.png',
                manual: 'file-asset/file/68d616d0c049b946004ada399a9f07ca.pdf',
                features: [
                    [
                        { title: 'PPE 3.2 µmol/J', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/1.svg' },
                        { title: 'Uniform High Light Intensity', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/2.svg' },
                        { title: 'Dimming Down to 25%', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/3.svg' },
                    ],
                    [
                        { title: 'All-Stage Growth', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/4.svg' },
                        { title: 'Superior Energy Efficiency', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/5.svg' },
                        { title: 'Excellent Heat Dissipation', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/6.svg' },
                    ]
                ]
            },
            {
                key: 'm8',
                serie: 'M8',
                url: RouteEnum.PROD_M8,
                variantId: '166225847447969809',
                picture: 'asset/width-1372/picture/3de9bc84cc80f18ed09d6644c52764ab.png',
                manual: 'file-asset/file/68d616d0c049b946004ada399a9f07ca.pdf',
                features: [
                    [
                        { title: 'PPE 3.2 µmol/J', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/1.svg' },
                        { title: 'Uniform High Light Intensity', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/2.svg' },
                        { title: 'Dimming Down to 25%', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/3.svg' },
                    ],
                    [
                        { title: 'All-Stage Growth', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/4.svg' },
                        { title: 'Superior Energy Efficiency', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/5.svg' },
                        { title: 'Excellent Heat Dissipation', icon: 'file-asset/file/2f6c89057d60b9c9a545243004d9abfb/1751963806723/6.svg' },
                    ]
                ]
            },
        ]
    },
    {
        key: 'dynamicmseries',
        name: 'M Dyna Series',
        shortName: 'M DYNA Series',
        url: RouteEnum.CAT_M_DYNAMIC_SERIES,
        isAccessory: false,
        description: [
            'Introducing the Matrix Dyna, a state-of-the-art LED grow light distinguished by its innovative spectrum-tuning capabilities.',
            'Compatible with all controllers through a universal 0-10V, the Dyna allows growers to seamlessly tailor the light spectrum to different growth stages via four customizable spectrum options.'
        ],
        children: [
            {
                key: 'm6dyna',
                serie: 'M6 Dyna',
                url: RouteEnum.PROD_M6_DYNA,
                variantId: '166275019186641928',
                picture: 'asset/width-1372/picture/72e979b4915ea793369c5f57aaf0ca39.png',
                manual: 'file-asset/file/cf5cf6ae8dbae5d81f675d469d1190b5.pdf',
                features: [
                    [
                        { title: 'Tunable Spectrum', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/1.svg' },
                        { title: 'PPE up to 3.2 µmol/J', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/2.svg' },
                        { title: 'Uniform High Light Intensity', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/3.svg' },
                    ],
                    [
                        { title: 'Superior Energy Efficiency', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/4.svg' },
                        { title: 'All-Stage Growth', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/5.svg' },
                        { title: 'Excellent Heat Dissipation', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/6.svg' },
                    ]
                ]
            },
            {
                key: 'm8dyna',
                serie: 'M8 Dyna',
                url: RouteEnum.PROD_M8_DYNA,
                variantId: '166276844279328989',
                picture: 'asset/width-1372/picture/47e6beccf08bc670c0b7e648057e77c1.png',
                manual: 'file-asset/file/cf5cf6ae8dbae5d81f675d469d1190b5.pdf',
                features: [
                    [
                        { title: 'Tunable Spectrum', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/1.svg' },
                        { title: 'PPE up to 3.2 µmol/J', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/2.svg' },
                        { title: 'Uniform High Light Intensity', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/3.svg' },
                    ],
                    [
                        { title: 'Superior Energy Efficiency', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/4.svg' },
                        { title: 'All-Stage Growth', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/5.svg' },
                        { title: 'Excellent Heat Dissipation', icon: 'file-asset/file/188677bffe62c2139de787b5db262d1d/1751963811335/6.svg' },
                    ]
                ]
            },
        ]
    },
    {
        key: 'fruv',
        name: 'FR & UV',
        shortName: 'FR & UV',
        url: RouteEnum.CAT_FRUV,
        isAccessory: false,
        description: [
            'Matrix FR & UV Bar are designed to complement professional grow lighting systems by providing precise spectrum supplementation for advanced cultivation control.',
            'These spectrum bars allow growers to fine-tune their lighting recipes with targeted far-red and UV wavelengths, enhancing specific plant responses and optimizing growth performance throughout different stages.'
        ],
        children: [
            {
                key: 'fr',
                serie: 'FR',
                url: RouteEnum.PROD_FR,
                variantId: '',
                picture: 'asset/width-686/picture/302ebb02d9ce85b2b85c9444e41c7028.png',
                manual: 'file-asset/file/91c6e5c48f97cd13a4edc590e0933ab9.pdf',
                features: [
                    [
                        { title: 'Attachable to All Matrix M Series', icon: 'file-asset/file/260e5a7addf9026d610048dce0a4f2c5.svg' },
                        { title: 'Top Efficacy Far Red Diodes', icon: 'file-asset/file/b7c69e186dafea9c3fe6ce826d17ad92.svg' },
                        { title: 'Quick Extention with Simple Daisy-chain Wiring', icon: 'file-asset/file/f810b7912b899e2b7ba7d680e8015b62.svg' },
                    ],
                    [
                        { title: 'IP66 Waterproof', icon: 'file-asset/file/e3ec1058692a12e996e72f301428db5b.svg' },
                        { title: '0-10V Smart Control', icon: 'file-asset/file/4891278eff06c1539e24be2e800350b5.svg' },
                    ]
                ],
            },
            {
                key: 'uv',
                serie: 'UV',
                url: RouteEnum.PROD_UV,
                variantId: '',
                picture: 'asset/width-686/picture/df68b2642f3e0c1159e4b38bf20f141c.png',
                manual: 'file-asset/file/91c6e5c48f97cd13a4edc590e0933ab9.pdf',
                features: [
                    [
                        { title: 'Attachable to All Matrix M Series', icon: 'file-asset/file/77f02259cb63a853dd8bfb6cc405b85a.svg' },
                        { title: 'UV-A 395nm', icon: 'file-asset/file/c00a6fc76228cfcaaeb86c2607ca68c5.svg' },
                        { title: 'Daisy Chain Wiring', icon: 'file-asset/file/64d08bf97a326681b29eeb76a95aab6c.svg' },
                    ],
                    [
                        { title: 'IP66 Waterproof', icon: 'file-asset/file/81344c9ff97fe1ea03ddff07fe20577a.svg' },
                        { title: '0-10V Dimming', icon: 'file-asset/file/10cf31ee70553a615f226ed3d65c7982.svg' },
                    ]
                ],
            }
        ]
    },
    {
        key: 'cloning',
        name: 'Cloning',
        shortName: 'CB',
        url: RouteEnum.CAT_LINEAR,
        isAccessory: false,
        description: [
            'The Matrix CB 18W represents a significant leap in horticultural lighting technology, outperforming traditional T5 fluorescent lights by a substantial margin.',
            'Specifically engineered for the cloning stage, these lights offer a full spectrum with an abundance of rich blue light, precisely tailored to foster optimal conditions for successful cloning.'
        ],
        children: [
            {
                key: 'cb',
                serie: 'CB',
                url: RouteEnum.PROD_CB,
                variantId: '165603202011292728',
                picture: 'asset/width-1372/picture/0c4a0cc1eb5a28ef1cd208e11d4a3e58.png',
                manual: '',
                features: [
                    [
                        { title: 'Rich Blue Light Spectrum', icon: 'file-asset/file/1265373ab8ddd69701730ce4351642db.svg' },
                        { title: 'Daisy Chain Capability', icon: 'file-asset/file/7f89e755699b6b9e76a59725c9babc0e.svg' },
                        { title: 'High Efficiency', icon: 'file-asset/file/5ba30258ac93fe3110d4b8629a7251c7.svg' },
                    ],
                    [
                        { title: 'IP66 Waterproof', icon: 'file-asset/file/f4969e4d57c22c87e62f34ba166cc6f5.svg' },
                        { title: 'Easy Installation', icon: 'file-asset/file/597bea55ecc1081832dee4ba3d433dbf.svg' },
                        { title: 'Long-Term Guarantee', icon: 'file-asset/file/67f1133b2adc5e5c407887af15bd46d9.svg' },
                    ]
                ],
            },
        ]
    },
    {
        key: 'linear',
        name: 'Linear',
        shortName: 'LTL',
        url: RouteEnum.CAT_CLONING,
        isAccessory: false,
        description: [
            'At Matrix, we recognize the importance of ensuring optimal lighting conditions for plants during their vegetative stage.',
            'That is why we are proud to present our state-of-the-art linear LED grow light, the Matrix LTL 200W, meticulously designed to stimulate robust foliar growth and sturdy root development.'
        ],
        children: [
            {
                key: 'ltl',
                serie: 'LTL',
                url: RouteEnum.PROD_LTL,
                variantId: '166249243745577133',
                picture: 'asset/width-1372/picture/e488d96dc16867819fc2eaabdead5076.png',
                manual: 'file-asset/file/dff0d41695bbae509355435cd32ecf5d/1733192173795/LTL-200W.pdf',
                features: [
                    [
                        { title: 'PPE 3.2 µmol/J', icon: 'file-asset/file/80f5c7e13787c7adbf4302278ddc1e15/1751963825345/2.svg' },
                        { title: '0-10V Dimming', icon: 'file-asset/file/80f5c7e13787c7adbf4302278ddc1e15/1751963825345/3.svg' },
                    ],
                    [
                        { title: '80% Red Spectrum', icon: 'file-asset/file/80f5c7e13787c7adbf4302278ddc1e15/1751963825345/1.svg' },
                        { title: 'For Vegetative Growth', icon: 'file-asset/file/80f5c7e13787c7adbf4302278ddc1e15/1751963825345/4.svg' },
                    ]
                ]
            },
        ]
    },
];

export const ACCESSORIES: ICategory[] = [
    {
        key: 'controller',
        name: 'Controller',
        shortName: 'Controller',
        isAccessory: true,
        url: RouteEnum.CAT_ACCESSORIES,
        description: [],
        children: [
            {
                key: 'mc2',
                serie: 'MC2',
                url: RouteEnum.PROD_MC2,
                variantId: '166115842866309129',
                picture: 'asset/width-1372/picture/b2b19324c9299c4735de66a5d8dcb5d6.png',
                manual: 'file-asset/file/1e6143982de516a7ee091e79899b0192/1769497614439/Matrix-MC2-Controller.pdf',
            },
        ]
    },
];